import axios from 'axios'
import { InformationCampaignQueryResponse, InformationCampaignModel } from './_models'
import { ID, Response } from "../../../../../_metronic/helpers"
import fileDownload from 'js-file-download'
import {toast} from "react-toastify";

const API_URL = "https://shifatr.org/api/information-campaign"
const API_FILE_URL = "https://shifatr.org/api/information-campaign"

const getInformationCampaigns = async (query: string): Promise<InformationCampaignQueryResponse> => {
    return await axios
    .get(`${API_URL}?${query}`)
  }

const createInformationCampaignFile = (informationCampaign: any): Promise<InformationCampaignModel | undefined> => {
  return axios

    .post(`${API_FILE_URL}`, informationCampaign,{
      headers: {
        "Content-Type": "multipart/form-data",
      }})
    .then((response: Response<InformationCampaignModel>) => response.data)
}

const deleteInformationCampaign = (parameterId: ID): Promise<void> => {
  return axios.delete(`${API_FILE_URL}/${parameterId}`).then(() => { })
}

const getHelpPdf = (): any => {
  return axios
    .get(`${API_URL}/getHelpDocument`, {responseType: 'blob'})
    .then((d: any) => d.data)
}

const getFileById = (id: any, fileName:any) => {
  return axios({
    responseType: "blob",
    method: "GET",
    url:`${API_URL}/download-information-campaign-file/${id}`,
  }).then((response) => {
    if(response.data)
    {
      console.log(response.data)
      const url = window.URL.createObjectURL(new Blob([response.data], {type: response.data.type}));
      window.open(url)
    }

  });
}

const downloadFileById = (id: any, fileName:any, intlnss?: any) => {
  let toastId: any = null;
  if (intlnss) {
    toastId = toast.info(intlnss.formatMessage({ id: 'DOWNLOAD_STARTED' }), {
      autoClose: false,
    });
  }


  return axios({
    responseType: "blob",
    method: "GET",
    url:`${API_URL}/download-information-campaign-file/${id}`,
  }).then((response) => {
    if(response.data)
    {
      const url = window.URL.createObjectURL(new Blob([response.data]));
      const link = document.createElement("a");
      link.href = url;
      link.setAttribute("download",`${fileName}`);
      document.body.appendChild(link);
      link.click();
    }

  })
    .catch((error) => {
      toast.error(intlnss.formatMessage({ id: 'DOWNLOAD_FAILED' }), {
        autoClose: false,
      });
    })
    .finally(()=> {
      if (toastId) {
        toast.dismiss(toastId);
      }
    });
}
const getChecklistAsPdf = (query: string) => {
  console.log(query)
  return axios({
    responseType: "blob",
    method: "GET",
    url: `${API_URL}/pdfreport?${query}`,
  }).then((response) => {
    fileDownload(response.data, "Report.pdf", "application/pdf");
  })
}

const getChecklistAsExcel = (query: string) => {
  return axios({
    responseType: "blob",
    method: "GET",
    url: `${API_URL}/excelreport?${query}`,
  }).then((response) => {
    fileDownload(response.data, "Report.xlsx");
  })
}


export { downloadFileById, getChecklistAsExcel, getChecklistAsPdf, getFileById, getInformationCampaigns, createInformationCampaignFile , deleteInformationCampaign, getHelpPdf }
